export default {
    services: {
        name:'Название услуги',
        nameforOnline:'Название для онлайн записи',
        serviceswithQuillwort:'Услуга с расходником',
        notSelected:'Не выбрана',
        priceFirst:'Стоимость у косметолога',
        priceSecond:'Стоимость у ведущего косметолога',
        description:'Описание',
        duration:'Длительность услуги'
    }
}